/* Knife Deck page (/pages/deck). Data from the ssc-account Worker via the app
   proxy, cards rendered by the theme's own card template (?view=card). */
(function () {
  'use strict';
  var root = document.getElementById('ssc-deck');
  if (!root) return;

  var PROXY = root.getAttribute('data-proxy') || '/apps/ssc';
  var loggedIn = root.getAttribute('data-logged-in') === 'true';
  var shareToken = null;
  try { shareToken = new URLSearchParams(window.location.search).get('share'); } catch (e) {}
  if (shareToken && !/^[0-9a-f]{16}$/.test(shareToken)) shareToken = null;

  var TIERS = ['common', 'uncommon', 'rare', 'magic', 'legendary', 'unique', 'mythic'];
  var q = function (sel) { return root.querySelector(sel); };
  var statusEl = q('[data-deck-status]');
  var grid = q('[data-deck-grid]');
  var stats = q('[data-deck-stats]');
  var toolbar = q('[data-deck-toolbar]');
  var shareBox = q('[data-deck-share-box]');
  var shareUrlEl = q('[data-deck-share-url]');
  var emptyEl = q('[data-deck-empty]');
  var signinEl = q('[data-deck-signin]');

  function set(key, text) { var el = root.querySelector('[data-deck="' + key + '"]'); if (el) el.textContent = text == null ? '' : text; }
  function status(text) { if (!text) { statusEl.hidden = true; return; } statusEl.hidden = false; statusEl.textContent = text; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmtDate(iso) { if (!iso) return ''; var d = new Date(iso); return isNaN(d.getTime()) ? '' : d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' }); }
  function json(r) { return r.json().then(function (b) { if (!r.ok) { var e = new Error(b && b.error || 'failed'); e.code = b && b.error; throw e; } return b; }); }

  function cardHtml(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?view=card', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; });
  }

  function tierOf(html) {
    var m = html.match(/data-tier="(?:tier-)?(common|uncommon|rare|magic|legendary|unique|mythic)"/i) || html.match(/\btier-(common|uncommon|rare|magic|legendary|unique|mythic)\b/i);
    return m ? m[1].toLowerCase() : null;
  }

  function render(deck, shared) {
    var cards = deck.cards || [];
    if (shared) {
      root.classList.add('is-shared');
      q('[data-deck-eyebrow]').textContent = 'Shared deck';
      q('[data-deck-title]').innerHTML = esc(deck.owner ? deck.owner + "'s Knife Deck" : 'A shared Knife Deck') + '<span class="sg-dot">.</span>';
      q('[data-deck-lede]').textContent = 'A deck shared from a Smart Sushi Chef account. Tick two cards to compare, or start your own deck with any knife in the collection.';
    } else if (deck.owner) {
      q('[data-deck-eyebrow]').textContent = deck.owner + "'s collection";
    }
    if (!cards.length) { status(''); emptyEl.hidden = false; return; }
    status('Dealing ' + cards.length + (cards.length === 1 ? ' card' : ' cards'));
    toolbar.hidden = false;
    Promise.all(cards.map(function (c) { return cardHtml(c.handle); })).then(function (htmls) {
      var best = -1, types = {}, shown = 0;
      grid.innerHTML = '';
      htmls.forEach(function (html, i) {
        var c = cards[i];
        var wrap = document.createElement('div');
        wrap.className = 'dk-slot';
        if (html && html.indexOf('card-wrap') > -1) {
          wrap.innerHTML = html;
          shown++;
          var t = tierOf(html);
          if (t && TIERS.indexOf(t) > best) best = TIERS.indexOf(t);
        } else {
          wrap.innerHTML = '<div class="dk-missing">This card is being reprinted. <a href="/products/' + esc(c.handle) + '">' + esc(c.title || c.handle) + '</a></div>';
        }
        if (c.type) types[c.type] = true;
        if (!shared) {
          var meta = document.createElement('div');
          meta.className = 'dk-meta';
          meta.innerHTML = '<span>' + (c.orderName ? 'Order ' + esc(c.orderName) : '') + '</span><b>' + esc(fmtDate(c.boughtAt)) + '</b>';
          wrap.appendChild(meta);
        }
        grid.appendChild(wrap);
      });
      status('');
      if (window.SSCCompare && window.SSCCompare.bind) { try { window.SSCCompare.bind(grid); } catch (e) {} }
      set('count', String(shown));
      set('count-sub', shown === 1 ? 'Card in the deck' : 'Cards in the deck');
      set('tier', best >= 0 ? (TIERS[best] === 'magic' ? 'Epic' : TIERS[best].charAt(0).toUpperCase() + TIERS[best].slice(1)) : '');
      set('types', String(Object.keys(types).length));
      if (!shared && cards[0]) { set('latest', cards[0].title ? cards[0].title.split(' ').slice(0, 2).join(' ') : ''); set('latest-sub', fmtDate(cards[0].boughtAt)); }
      else { set('latest', deck.owner || ''); set('latest-sub', 'Deck owner'); }
      stats.hidden = false;
    });
  }

  // Art side toggle flips every rendered card wrap.
  toolbar.querySelectorAll('[data-art]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      toolbar.querySelectorAll('[data-art]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      grid.querySelectorAll('[data-art-mode]').forEach(function (el) { el.setAttribute('data-art-mode', btn.getAttribute('data-art')); });
    });
  });

  var shareBtn = q('[data-deck-share]');
  if (shareBtn) shareBtn.addEventListener('click', function () {
    shareBtn.disabled = true;
    fetch(PROXY + '/deck/share', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: '{}' })
      .then(json)
      .then(function (b) { shareUrlEl.textContent = b.url; shareBox.hidden = false; })
      .catch(function () { status('Could not create a share link right now.'); })
      .then(function () { shareBtn.disabled = false; });
  });
  var copyBtn = q('[data-deck-copy]');
  if (copyBtn) copyBtn.addEventListener('click', function () {
    var url = shareUrlEl.textContent;
    var done = function () { copyBtn.textContent = 'Copied'; setTimeout(function () { copyBtn.textContent = 'Copy'; }, 1800); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, done); else done();
  });

  if (shareToken) {
    fetch(PROXY + '/deck/share/' + shareToken, { credentials: 'same-origin' })
      .then(json)
      .then(function (snap) { render({ owner: snap.owner, cards: (snap.handles || []).map(function (h) { return { handle: h }; }) }, true); })
      .catch(function () { status('That share link is not valid any more.'); });
  } else if (!loggedIn) {
    status('');
    signinEl.hidden = false;
  } else {
    fetch(PROXY + '/deck', { credentials: 'same-origin' })
      .then(json)
      .then(function (deck) { render(deck, false); })
      .catch(function (err) {
        if (err.code === 'not_logged_in') { status(''); signinEl.hidden = false; }
        else status('Your deck is not loading right now. Try again in a minute.');
      });
  }
})();
